
















import Vue from 'vue';
import { deleteAssignment } from '@/repository/assignment';

export default Vue.extend({
  props: [
    'assignment',
  ],
  data: () => ({
    dialog: false,
    isLoading: false,
  }),
  methods: {
    hide() {
      this.dialog = false;
    },
    perform() {
      this.isLoading = true;
      deleteAssignment(this.assignment)
        .then(() => {
          this.isLoading = false;
          this.hide();
          console.log('aa');
          this.$router.push('/dashboard');
        }).catch((err) => {
          console.log(`Delete Assignment ${this.assignment.id} error:`, err);
          this.isLoading = false;
        });
    },
  },
});
